import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { getCommunicationAttachmentBlob } from '../../api/communicationApi';
import T from '../common/T';

export default function ChatMediaAttachment({
  messageId, attachmentIndex, mediaType, filename, sourceUrl, isStored, sx,
}) {
  const [url, setUrl] = useState('');
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(isStored);
  const [attempt, setAttempt] = useState(0);
  const externalSource = isStored ? null : sourceUrl;
  useEffect(() => {
    if (!isStored) {
      setUrl(externalSource);
      setLoading(false);
      return undefined;
    }
    const controller = new AbortController();
    let objectUrl;
    setUrl('');
    setLoading(true);
    setFailed(false);
    getCommunicationAttachmentBlob(messageId, attachmentIndex, { signal: controller.signal })
      .then((blob) => {
        if (controller.signal.aborted) return;
        if (!blob.size) throw new Error('Empty media');
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => { if (!controller.signal.aborted) setFailed(true); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  // A provider reference becoming a stored reference must not restart playback.
  }, [messageId, attachmentIndex, isStored, externalSource, attempt]);
  if (loading) return <Box role="status" sx={{ p: 1 }}><CircularProgress size={18} /><T> Wird geladen…</T></Box>;
  if (failed) return (
    <Alert severity="warning"><T>
      Datei konnte nicht geladen werden.
      </T><Button size="small" onClick={() => setAttempt((value) => value + 1)}><T>Erneut laden</T></Button>
    </Alert>
  );
  return <Box component={mediaType} aria-label={filename} src={url} controls onError={() => setFailed(true)} sx={sx} />;
}

ChatMediaAttachment.propTypes = {
  messageId: PropTypes.string.isRequired,
  attachmentIndex: PropTypes.number.isRequired,
  mediaType: PropTypes.oneOf(['audio', 'video']).isRequired,
  filename: PropTypes.string.isRequired,
  sourceUrl: PropTypes.string,
  isStored: PropTypes.bool.isRequired,
  sx: PropTypes.object,
};
